import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { SettingContext } from "../../routes";
import { formatDate } from "../../services/util";
import { useQuery } from "react-query";
import CustomTable from "../common/Table";
import { Card, Select, Skeleton } from "antd";
import CustomHeader from "../common/Header";
import HTTP from "../../services/httpService";
const { Option } = Select;

const shiftFilterOptions = [
    { lable: "Category", value: 1, isDefault: true },
    { lable: "Status", value: 2 },
    { lable: "Originator", value: 3 },
    { lable: "Originator’s name", value: 4 },
];

const HotelShiftNotes = () => {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const { hotel_id } = useParams();
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [currentPage, setCurrentPage] = useState(1);
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids: [hotel_id],
        column: 1,
    });

    const {
        status: hotelShiftNotesStatus,
        data: hotelShiftNotesRes,
        refetch: fetchHotelShiftNotesDetails,
    } = useQuery(
        `shiftNotes${hotel_id}`,
        async () => {
            return await HTTP(
                "/dashboard/getDashboardShiftNotesCountsForHotel",
                {
                    ...formData,
                },
            );
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchHotelShiftNotesDetails();
    }, []);

    useEffect(() => {
        fetchHotelShiftNotesDetails();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    function formatShiftNotesData(dataShiftNotes) {
        if (dataShiftNotes && dataShiftNotes.length > 0) {
            dataShiftNotes.map((item) => {
                if (formData.column == 1) {
                    if (item.category_id == 1)
                        return (item.lable = "Knowledge base");
                    else if (item.category_id == 2)
                        return (item.lable = "Issue");
                    else if (item.category_id == 3)
                        return (item.lable = "Request");
                    else if (item.category_id == 4)
                        return (item.lable = "Information");
                } else if (formData.column == 2) {
                    if (item.status == 1) return (item.lable = "Pending");
                    if (item.status == 2) return (item.lable = "Acknowledged ");
                    if (item.status == 3) return (item.lable = "Completed ");
                } else if (formData.column == 3) {
                    if (item.originator_id == 1) return (item.lable = "Guest");
                    if (item.originator_id == 2) return (item.lable = "Staff");
                    if (item.originator_id == 3) return (item.lable = "Agent");
                    if (item.originator_id == 4)
                        return (item.lable = "Manager");
                } else if (formData.column == 4) {
                    if (item.originator_id == 1)
                        return (item.lable = `${item.originator_name} (Guest)`);
                    if (item.originator_id == 2)
                        return (item.lable = `${item.originator_name} (Staff)`);
                    if (item.originator_id == 3)
                        return (item.lable = `${item.originator_name} (Agent)`);
                    if (item.originator_id == 4)
                        return (item.lable = `${item.originator_name} (Manager)`);
                }
            });
        }
        setTableData(dataShiftNotes);
    }

    useEffect(() => {
        if (hotelShiftNotesStatus === "success") {
            const { data: hotelShiftNotesData, total } = hotelShiftNotesRes;
            setTotalRecords(total);
            formatShiftNotesData(hotelShiftNotesData);
        }
    }, [hotelShiftNotesStatus, hotelShiftNotesRes]);

    function handleSelectChange(e) {
        const updatedFormData = { ...formData, column: e };
        setFormData(updatedFormData);
    }

    const columns = [
        {
            title: shiftFilterOptions[Number(formData.column) - 1].lable,
            dataIndex: "lable",
            key: "lable",
        },
        {
            title: "Shift Notes",
            dataIndex: "shift_notes_count",
            key: "shift_notes_count",
        },
    ];

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        setFormData({
            ...formData,
            page: current - 1,
            limit: pageSize,
        });
        setCurrentPage(current);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Select
                id="shiftNotesFilter"
                style={{ margin: "10px 0" }}
                defaultValue={
                    shiftFilterOptions.find((e) => {
                        if (e?.isDefault) return true;
                    }).lable
                }
                showSearch
                allowClear={false}
                onChange={handleSelectChange}
            >
                {shiftFilterOptions.map((e) => (
                    <Option key={`${e.value}`}>{e.lable}</Option>
                ))}
            </Select>
            {hotelShiftNotesStatus === "loading" ||
            hotelShiftNotesStatus === "idle" ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    noOfrecords={totalRecords}
                    currentPage={currentPage}
                    handleTableChange={handleTableChange}
                    rowKey="hotel_id"
                />
            )}
        </Card>
    );
};

export default HotelShiftNotes;
